import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Radium from 'higher-order-components/configured-radium/'
import SwipeableViews from 'react-swipeable-views'
import { BackgroundImage } from 'containers'
import { ImageDisclaimer } from 'containers'

class GalleryFullWidth extends Component {
  constructor(props) {
    super(props)
    this.state = {
      active: 0,
      highlight: 0
    }
    this.handleChange = (index, indexLatest) => {
      this.active = index
    }

    this.toggleNext = () => {
      this.setState({
        active: this.state.active + 1,
        highlight: this.state.active === this.props.galleryItems.length - 2 ? 0 : undefined
      })
    }

    this.togglePrev = () => {
      this.setState({
        active: this.state.active - 1,
        highlight: this.state.active === 1 ? 0 : undefined
      })
    }
  }
  static propTypes = {
    galleryItems: PropTypes.array
  }

  /**
   * @param {String} name - Name to displayed on accordion.
   * @param {Array} components - Array of components.
   * @returns {ReactElement} React Component
   */
  render() {
    const { highlight, active } = this.state
    const { galleryItems } = this.props
    return (
      <div style={styles.base} data-test="gallery-full-width">
        <SwipeableViews
          animateTransitions
          index={active}
          onChangeIndex={this.handleChange}
          containerStyle={{
            marginLeft: `${highlight * 10}%`,
            transition: '0.7s',
            width: '100%',
            display: 'flex',
            alignContent: 'center'
          }}
          slideStyle={{
            alignSelf: 'center',
            overflow: 'hidden'
          }}>
          {galleryItems.map((component, index) => (
            <figure key={index} style={styles.figure}>
              <div>
                <BackgroundImage position="absolute" src={component.imageSrc} />
                <img src={component.imageSrc} style={styles.img} />
              </div>
              {component.title && (
                <ImageDisclaimer
                  textAlign="left"
                  size="small"
                  uppercase
                  content={component.title} />
              )}
            </figure>
          ))}
        </SwipeableViews>
        {active > 0 && (
          <div
            style={styles.scrollLeft}
            onMouseEnter={() => this.setState({ highlight: 1 })}
            onMouseLeave={() => this.setState({ highlight: 0 })}
            onClick={this.togglePrev} />
        )}
        {active < galleryItems.length - 1 && (
          <div
            style={styles.scrollRight}
            onMouseEnter={() => this.setState({ highlight: -1 })}
            onMouseLeave={() => this.setState({ highlight: 0 })}
            onClick={this.toggleNext} />
        )}
      </div>
    )
  }
}

export default Radium(GalleryFullWidth)

const styles = {
  base: {
    position: 'relative',
    width: '100%',
    overflow: 'hidden'
  },
  img: {
    height: '100%',
    width: '100%',
    position: 'relative',
    zIndex: 2,
    opacity: 0
  },
  figure: {
    color: 'white',
    margin: 0,
    position: 'relative',
    height: '100%',
    width: '100%'
  },
  scrollLeft: {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '25%',
    height: '100%',
    display: 'none',
    backgroundColor: 'rgba(100, 100, 100, 0)',
    '@media (min-width: 768px)': {
      display: 'inline-block'
    }
  },
  scrollRight: {
    position: 'absolute',
    right: 0,
    top: 0,
    width: '25%',
    height: '100%',
    display: 'none',
    backgroundColor: 'rgba(100, 100, 100, 0)',
    '@media (min-width: 768px)': {
      display: 'inline-block'
    }
  }
}



// WEBPACK FOOTER //
// ./src/containers/gallery-full-width/index.jsx